import { angularServicesNames } from "@topline/services/angularServicesNames";
import { GridValueEditorService } from "../common/gridValueEditor/service/gridValueEditorService";


class RollingForecastChartAndTableComponentController {
    public brand: $TSFixMe;
    public parameters: $TSFixMe;
    public datasetOverride: $TSFixMe;
    public options: $TSFixMe;
    public visualElement: $TSFixMe;
    public showValue: $TSFixMe = false;
    public labels: $TSFixMe;
    public skuSplitValueEditorOptions: $TSFixMe;
    public chartInstance: $TSFixMe;
    public itemsToDisplay: $TSFixMe;
    public serverOperation: $TSFixMe;
    public rollingForecastData: $TSFixMe;
    public brandData: $TSFixMe;

    static $inject = [
        '$scope',
        'dtpChartService',
        '$timeout',
        GridValueEditorService.componentName,
        'mlDataService',
        'uibButtonConfig',
        angularServicesNames.$translate,
        'FileSaver'
    ];

    constructor(
        private $scope: $TSFixMe,
        private dtpChartService: $TSFixMe,
        private $timeout: ng.ITimeoutService,
        private gridValueEditorService: GridValueEditorService,
        private mlDataService: $TSFixMe,
        private uibButtonConfig: $TSFixMe,
        private $translate: ng.translate.ITranslateService,
        private FileSaver: $TSFixMe
    ) {
        this.uibButtonConfig.activeClass = 'active-element';
        this.showValue = false;
        this.options = { scales: { yAxes: [{ ticks: { suggestedMin: 0 } }] } };
        this.$scope.$on('LanguageChanged', () => this.resetChartTranslations());
        this.resetChartTranslations();
    }

    $onInit() {
        this.visualElement = 'chart';
        this.labels = this.dtpChartService.preparePeriodsAndLabels(this.parameters.forecastStartDate, this.parameters.forecastEndDate).periods;
        this.skuSplitValueEditorOptions = {
            gridName: "skuSplitValueEditorOptions",
            header: this.gridValueEditorService.prepareHeaderData(this.parameters.forecastStartDate, this.parameters.forecastEndDate),
            readOnly: true,
            showFooter: true,
        };
        this.$scope.$watch('$ctrl.brand', () => this.refreshDebounce(), true);
    }

    public showValueChanged = () => this.displayRollingForecastData();

    public exportChart = () => {
        const canvas = this.chartInstance.chart.canvas;
        canvas.toBlob((blob: $TSFixMe) => {
            this.FileSaver.saveAs(blob, 'wykres.png');
        }, 'image/png', 1);
    };

    private refreshDebounce() {
        if (angular.isDefined((this.$scope as any).watchTimeout)) {
            this.$timeout.cancel((this.$scope as any).watchTimeout);
        }
        (this.$scope as any).watchTimeout = this.$timeout(() => this.refreshData(), 500);
    }

    private resetChartTranslations() {
        this.datasetOverride = [
            { label: this.$translate.instant('FORECAST.PRODUCT.ROLLING_FORECAST.PRODUCT_CHART') },
            { label: this.$translate.instant('FORECAST.PRODUCT.ROLLING_FORECAST.RF_CHART') }
        ];
    }

    private refreshData() {
        if (!this.brand) {
            return;
        }
        this.serverOperation = this.mlDataService.getRollingForecasts(
            this.parameters.forecastStartDate, this.parameters.forecastEndDate,
            this.brand.skus).then((data: $TSFixMe) => {
                this.rollingForecastData = data;
                this.displayRollingForecastData();
            });
    }

    private displayRollingForecastData() {
        this.brandData = this.showValue ? this.rollingForecastData.brandValue : this.rollingForecastData.brandVolume;
        this.populateDataToSku(this.rollingForecastData.skus);
        this.refreshChart();
    }

    private refreshChart() {
        this.itemsToDisplay = [
            this.showValue ? this.brand.forecast.value.pmForecast : this.brand.forecast.volume.pmForecast,
            this.showValue ? this.rollingForecastData.brandValue : this.rollingForecastData.brandVolume
        ];
    }

    private populateDataToSku(skus: $TSFixMe) {
        this.skuSplitValueEditorOptions.gridData = _.sortBy(skus.map((s: $TSFixMe) => {
            return {
                header: s.name,
                values: this.showValue ? s.value : s.volume
            };
        }), 'header');

        if (this.skuSplitValueEditorOptions.gridData.length > 0) {
            const sum = this.skuSplitValueEditorOptions.gridData[0].values.slice();
            for (let i = 1; i < this.skuSplitValueEditorOptions.gridData.length; i++) {
                for (let j = 0; j < sum.length; j++) {
                    sum[j] += this.skuSplitValueEditorOptions.gridData[i].values[j];
                }
            }
            this.skuSplitValueEditorOptions.footerData = sum;
        }
    }
}

export class RollingForecastChartAndTableComponent implements ng.IComponentOptions {
    static componentName = 'rollingForecastChartAndTable';
    bindings = {
        brand: '<',
        parameters: '<'
    };
    controller = RollingForecastChartAndTableComponentController;
    template = require('./rollingForecastChartAndTableComponent.html');
}

angular.module('topline.modules').component(RollingForecastChartAndTableComponent.componentName, new RollingForecastChartAndTableComponent());